export default __webpack_public_path__ + "static/media/space1.de426ef5.png";